@if (visible()) {
  <div class="info-modal-overlay" (click)="onOverlayClick($event)">
    <div class="info-modal-panel" role="dialog" aria-modal="true" [attr.aria-label]="title()">
      <button type="button" class="info-modal-close" (click)="close()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>

      <div class="info-modal-content">
        <div class="info-modal-icon-wrap">
          <mat-icon class="info-modal-icon">info</mat-icon>
        </div>

        <h2 class="info-modal-title">{{ title() }}</h2>

        @if (sections().length === 1 && !sections()[0].label) {
          <p class="info-modal-message">{{ sections()[0].body.join(' ') }}</p>
        } @else {
          <dl class="info-modal-fields">
            @for (section of sections(); track section.label) {
              <div class="info-modal-field">
                @if (section.label) {
                  <dt class="info-modal-field-label">{{ section.label }}</dt>
                }
                <dd class="info-modal-field-body">
                  @for (line of section.body; track line) {
                    <p>{{ line }}</p>
                  }
                </dd>
              </div>
            }
          </dl>
        }

        <div class="info-modal-actions">
          <button type="button" class="info-modal-confirm" (click)="close()">
            <mat-icon>check_circle</mat-icon>
            <span>Got it</span>
          </button>
        </div>
      </div>
    </div>
  </div>
}
